<script>
  import { onMount, onDestroy } from "svelte"
  import { ResizeObserver } from '@juggle/resize-observer'
  import detectElementOverflow from "detect-element-overflow"
  import throttle from "lodash/throttle"

  let overflownLeft = false
  let overflownRight = false

  let parent, child

  const throttledDetectOverflow = throttle(detectOverflow, 100)
  const resizeObserver = new ResizeObserver(_entries => detectOverflow())

  onMount(() => {
    resizeObserver.observe(child)
    resizeObserver.observe(parent)
    parent.addEventListener("scroll", throttledDetectOverflow)
  })

  function detectOverflow() {
    const collisions = detectElementOverflow(parent, child)
    overflownLeft = collisions.overflowLeft < 0
    overflownRight = collisions.overflowRight < -1.0
  }

  onDestroy(() => {
    resizeObserver.disconnect()
    parent.removeEventListener("scroll", throttledDetectOverflow)
  })
</script>

<div
  class="root"
  class:overflow_left={overflownLeft}
  class:overflow_right={overflownRight}>
  <div class="parent" bind:this={parent}>
    <div class="content" bind:this={child}>
      <slot />
    </div>
  </div>
</div>

<style>
  .root {
    width: 100%;
    position: relative;
  }

  .parent {
    width: 100%;

    display: flex;
    flex-wrap: nowrap;

    overflow-x: scroll;

    scrollbar-width: none;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }

  .parent::-webkit-scrollbar {
    display: none;
  }

  .root::before,
  .root::after {
    content: "";

    width: 1.25em;
    height: 100%;

    position: absolute;
    top: 0;

    pointer-events: none;

    opacity: 0;
    transition: opacity linear 0.1s;

    background: var(--main-background-color);
  }

  .root::before {
    left: 0;

    background: linear-gradient(
      90deg,
      rgba(var(--main-background-color-rgb), 1) 0%,
      rgba(var(--main-background-color-rgb), 0) 100%
    );
  }

  .root::after {
    right: 0;

    background: linear-gradient(
      270deg,
      rgba(var(--main-background-color-rgb), 1) 0%,
      rgba(var(--main-background-color-rgb), 0) 100%
    );
  }

  .overflow_left::before {
    opacity: 1;
  }

  .overflow_right::after {
    opacity: 1;
  }

  .content {
    display: flex;
    flex-wrap: nowrap;
  }
</style>
